// feeds TRANSCRIPTS - list page
import { Link } from "react-router-dom";
import React from "react";
import Seo from "./Seo";
// import React from "react";
//import ResourcesList from "./assets/resources/ResourcesList";


function MainContent7({resource}) {
  // const article = ResourcesList.find(article => article.objectName === articleId);
  // console.log('MC4', ResourcesList);
  //console.log('mc4', resource)
  // CHANGE Resources List to {resource.heading}
    return (
      <>
      <Seo title={resource.tabHeading} description={resource.metaDescription} keywords={resource.keywords} />
      <h2 className="sectionHeader">{resource.pageHeading}</h2>
      <p className="main marginClear paddingClear"><b>NOTE: </b>{resource.refresh}</p>
      <div className="main">
        <div className="rListCont"><ol className="ulNone">
        {resource.list.map((listItem, li) => {
          // console.log(listItem.quotes.id);
            return ( 
                <li key={li} className="rList">
                <Link to={`/Transcripts/${listItem.firstName}/${listItem.quotes[0].id}`} 
                      title={listItem.objectName} 
                      className="epLinks citeTitle">  
                <div className="rLinksDiv">
                <p className="pTransTitle">{listItem.by} {listItem.lastName}</p>
                {listItem.quotes.map((quoteList, i) => {
                  return (
                      <React.Fragment key={i}>                   
                      <p className="rTitle transcripts"><span className="rListFrom">{quoteList.from}</span>{quoteList.title} <i className="rListFrom">{quoteList.date}</i></p>
                      <p className="short">{quoteList.short}</p>

                      <hr />
                      </React.Fragment>
                    )
                })}
                
                </div></Link></li>
                        
            )
        })}
        </ol></div>
        
        
      </div>
      </>
    );
  };
  export default MainContent7;

